import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import Alert from "react-s-alert";
import SalesPersonTasksService from "../utils/SalesPersonTasksService";

class TaskDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      task: props.task,
      newComment: "",
      submittingComment: false,
      editingTitle: false,
      availableTypes: [],
      users: props.users || []
    };

    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.handleCommentSubmit = this.handleCommentSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleTitleEdit = this.handleTitleEdit.bind(this);
    this.handleTitleSave = this.handleTitleSave.bind(this);
  }

  componentDidMount() {
    // Fetch available types
    SalesPersonTasksService.getOptions()
      .then(data => {
        // Filter out "Sales Overdue" - it's a system-managed type
        const types = (data.types || []).filter(type => type !== 'Sales Overdue');
        this.setState({
          availableTypes: types
        });
      })
      .catch(error => {
        console.error("Failed to load options:", error);
      });
  }



  handleCommentChange(event) {
    this.setState({ newComment: event.target.value });
  }

  handleCommentSubmit(event) {
    event.preventDefault();
    
    if (!this.state.newComment.trim()) {
      Alert.error("Comment cannot be empty");
      return;
    }

    this.setState({ submittingComment: true });

    SalesPersonTasksService.addComment(this.state.task.id, this.state.newComment)
      .then(response => {
        Alert.success("Comment added successfully");
        
        // Update task with new comment
        const updatedTask = { ...this.state.task };
        updatedTask.comments = [response.comment, ...(updatedTask.comments || [])];
        updatedTask.comments_count = (updatedTask.comments_count || 0) + 1;
        
        this.setState({
          task: updatedTask,
          newComment: "",
          submittingComment: false
        });
      })
      .catch(error => {
        const errorMsg = error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors.join(", ")
          : "Failed to add comment";
        Alert.error(errorMsg);
        this.setState({ submittingComment: false });
      });
  }

  handleTitleEdit() {
    this.setState({ editingTitle: true });
  }

  handleTitleSave(newValue) {
    // Don't save if value hasn't changed
    if (this.state.task.title === newValue) {
      this.setState({ editingTitle: false });
      return;
    }

    const updateData = { title: newValue };
    
    SalesPersonTasksService.update(this.state.task.id, updateData)
      .then((response) => {
        const updatedTask = response.task || { ...this.state.task, title: newValue };
        this.setState({ 
          task: updatedTask,
          editingTitle: false
        });
      })
      .catch(error => {
        const errorMsg = error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors.join(", ")
          : "Failed to update task";
        Alert.error(errorMsg);
        this.setState({ editingTitle: false });
      });
  }

  handleFieldChange(field, newValue) {
    // Don't save if value hasn't changed
    if (this.state.task[field] === newValue) {
      return;
    }

    const updateData = { [field]: newValue };
    
    SalesPersonTasksService.update(this.state.task.id, updateData)
      .then((response) => {
        // Use the response data to update the task with all fields including assignee_name
        const updatedTask = response.task || { ...this.state.task, [field]: newValue };
        this.setState({ 
          task: updatedTask
        });
      })
      .catch(error => {
        const errorMsg = error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors.join(", ")
          : "Failed to update task";
        Alert.error(errorMsg);
      });
  }

  render() {
    const { onClose, isAdmin } = this.props;
    const { task, newComment, submittingComment, editingTitle, availableTypes, users } = this.state;

    const titleCase = str => {
      if (!str) return str;
      return str.replace(/_/g, " ").replace(/\w\S*/g, txt => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    };

    const taskTitle = task.type === 'Sales Overdue' ? 'Overdue Sale' : task.title;
    const isSalesOverdue = task.type === 'Sales Overdue';

    return (
      <Modal show={true} onHide={onClose} bsSize="large">
        <Modal.Header closeButton>
          <Modal.Title>
            {isSalesOverdue ? (
              <span>{taskTitle}</span>
            ) : editingTitle ? (
              <input
                type="text"
                defaultValue={task.title}
                onBlur={(e) => this.handleTitleSave(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    this.handleTitleSave(e.target.value);
                  }
                }}
                autoFocus
                style={{ width: "100%", fontSize: "18px", padding: "4px 8px", color: "#333", border: "1px solid #ccc", borderRadius: "4px" }}
              />
            ) : (
              <span
                onClick={this.handleTitleEdit}
                style={{ cursor: "pointer" }}
                title="Click to edit title"
              >
                {taskTitle} <i className="fa fa-pencil" style={{ fontSize: "14px", marginLeft: "8px", color: "#fff" }}></i>
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div className="row">
            <div className="col-md-12">
              <h4 style={{ marginBottom: "20px" }}>Task Details</h4>
              
              <div style={{ marginBottom: "30px" }}>
                {/* Row 1: Due Date and Type */}
                <div style={{ display: "flex", gap: "20px", marginBottom: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontWeight: "600", marginBottom: "5px", color: "#555" }}>Due Date</label>
                    <input
                      type="date"
                      value={task.due_date || ""}
                      onChange={(e) => this.handleFieldChange('due_date', e.target.value)}
                      style={{ 
                        padding: "8px 12px", 
                        width: "100%",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        fontSize: "14px",
                        backgroundColor: "white",
                        cursor: "text"
                      }}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontWeight: "600", marginBottom: "5px", color: "#555" }}>Type</label>
                    <select
                      value={task.type || ""}
                      onChange={(e) => this.handleFieldChange('type', e.target.value)}
                      disabled={isSalesOverdue}
                      style={{ 
                        padding: "8px 12px", 
                        width: "100%",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        fontSize: "14px",
                        backgroundColor: isSalesOverdue ? "#f5f5f5" : "white",
                        cursor: isSalesOverdue ? "not-allowed" : "pointer"
                      }}
                    >
                      <option value="">No type</option>
                      {isSalesOverdue && task.type && (
                        <option value={task.type}>{titleCase(task.type)}</option>
                      )}
                      {availableTypes.map(type => (
                        <option key={type} value={type}>
                          {titleCase(type)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Row 2: Assignee (if admin) */}
                {isAdmin && (
                  <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", fontWeight: "600", marginBottom: "5px", color: "#555" }}>Assignee</label>
                    <select
                      value={task.assignee_id || ""}
                      onChange={(e) => this.handleFieldChange('assignee_id', e.target.value)}
                      style={{ 
                        padding: "8px 12px", 
                        width: "100%",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        fontSize: "14px",
                        backgroundColor: "white",
                        cursor: "pointer"
                      }}
                    >
                      <option value="">Unassigned</option>
                      {users
                        .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                        .map(user => (
                          <option key={user.id} value={user.id}>
                            {user.name}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                {/* Row 2.5: Status */}
                <div style={{ marginBottom: "15px" }}>
                  <label style={{ display: "block", fontWeight: "600", marginBottom: "5px", color: "#555" }}>Status</label>
                  <select
                    value={task.status || "to_do"}
                    onChange={(e) => this.handleFieldChange('status', e.target.value)}
                    style={{ 
                      padding: "8px 12px", 
                      width: "100%",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      fontSize: "14px",
                      backgroundColor: "white",
                      cursor: "pointer"
                    }}
                  >
                    <option value="to_do">To Do</option>
                    <option value="done_by_sales_rep">Done by Sales Rep</option>
                    {isAdmin && <option value="approved">Approved by Admin</option>}
                  </select>
                </div>

                {/* Row 3: Related Deal and Created */}
                <div style={{ display: "flex", gap: "20px", marginBottom: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontWeight: "600", marginBottom: "5px", color: "#555" }}>Related Deal</label>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <input
                        type="number"
                        value={task.deal_id || ""}
                        placeholder="Deal ID"
                        onChange={(e) => this.handleFieldChange('deal_id', e.target.value)}
                        disabled={isSalesOverdue}
                        style={{ 
                          flex: 1,
                          padding: "8px 12px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          fontSize: "14px",
                          backgroundColor: isSalesOverdue ? "#f5f5f5" : "white",
                          cursor: isSalesOverdue ? "not-allowed" : "text"
                        }}
                      />
                      {task.deal_id && (
                        <Link to={`/m1/deals/${task.deal_id}`} target="_blank" style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                          View <i className="fa fa-external-link"></i>
                        </Link>
                      )}
                    </div>
                  </div>

                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontWeight: "600", marginBottom: "5px", color: "#555" }}>Created</label>
                    <div style={{ color: "#666", fontSize: "14px", padding: "8px 0" }}>
                      <Moment format="MMMM DD, YYYY h:mm A">{task.created_at}</Moment>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "30px" }}>
                <h4>Comments ({task.comments_count || 0})</h4>
                
                <form onSubmit={this.handleCommentSubmit} style={{ marginBottom: "20px" }}>
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Add a comment..."
                      value={newComment}
                      onChange={this.handleCommentChange}
                      disabled={submittingComment}
                    />
                  </div>
                  <Button
                    type="submit"
                    bsStyle="success"
                    bsSize="small"
                    disabled={submittingComment || !newComment.trim()}
                  >
                    {submittingComment ? "Adding..." : "Add Comment"}
                  </Button>
                </form>

                <div>
                  {task.comments && task.comments.length > 0 ? (
                    task.comments.map(comment => (
                      <div
                        key={comment.id}
                        style={{
                          backgroundColor: "#f8f9fa",
                          padding: "10px",
                          borderRadius: "4px",
                          marginBottom: "10px",
                          border: "1px solid #dee2e6"
                        }}
                      >
                        <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>
                          <strong>{comment.user_name}</strong>
                          <span style={{ marginLeft: "10px" }}>
                            <Moment fromNow>{comment.created_at}</Moment>
                          </span>
                        </div>
                        <div style={{ whiteSpace: "pre-wrap" }}>{comment.content}</div>
                      </div>
                    ))
                  ) : (
                    <div style={{ textAlign: "center", color: "#999", padding: "20px" }}>
                      No comments yet
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    );
  }
}

export default TaskDetailModal;
